import * as UIActions from "./uiAction";
import * as UserApi from '../services/user'
import { AppConfig } from '../configs'

const { client } = AppConfig

// Handle Logout
export const USER_LOGOUT = "USER_LOGOUT";
export const userLogout = () => ({
  type: USER_LOGOUT,
});
export const logout = () => (dispatch) => {
  dispatch(UIActions.showSuccess('Logout Successfully'));
  dispatch(userLogout())
};

export const USER_LOGIN = "USER_LOGIN";
export const userLogin = (data) => ({
  type: USER_LOGIN,
  data
});
export const login = (data) => async (dispatch) => {
  dispatch(UIActions.appLoading());
  try {
    const res = await client.query({
      query: UserApi.login,
      variables: data,
      fetchPolicy: "cache-first"
    })
    dispatch(userLogin(res.data.login));
    dispatch(UIActions.appReady());
    return true
  } catch (err)  {
      dispatch(UIActions.appReady());
      if (err.graphQLErrors) 
        dispatch(UIActions.addError(err.graphQLErrors.map(item => item.message).join(". ")))
      else 
        dispatch(UIActions.addError("Unable to login"))
      return false
  }
};
export const register = (data) => async (dispatch) => {
  dispatch(UIActions.appLoading())
  try {
    await client.mutate({
      mutation: UserApi.register,
      variables: data
    })
    dispatch(UIActions.showSuccess('Account created successfully.'))
    dispatch(UIActions.appReady());
    return true
  } catch (err) {
    dispatch(UIActions.appReady());
    if (err.graphQLErrors) 
      dispatch(UIActions.addError(err.graphQLErrors.map(item => item.message).join(". ")))
    else 
      dispatch(UIActions.addError("Some error occur. Please try again later."))
    return false
  }
}

// Update User Information
export const USER_INFO_UPDATE = "USER_INFO_UPDATE";
export const updateUserInfo = (data) => ({
  type: USER_INFO_UPDATE,
  data
});


// WEBPACK FOOTER //
// ./src/actions/userAction.js